import { FC } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';
import { useComponentId } from '@telialt/utils/src/hooks';
import { usePathname } from '@telialt/utils/src/pathname';

import { getIsLinkActive } from '../../utils/path';
import { MenuItemBadge } from '../MenuItemBadge/MenuItemBadge';
import { MenuColumnItem } from './MenuColumnItem';
import { MenuColumnGroup, MenuColumnHeading, MenuColumnHeadingLink, StyledMenuColumn } from './MenuItemDropdown.styles';

interface MenuColumnProps {
    item: NavigationItem;
}

export const MenuColumn: FC<MenuColumnProps> = ({ item }) => {
    const columnId = useComponentId('heading');

    const pathname = usePathname();
    const isActive = item.url ? getIsLinkActive(item.url, pathname) : false;

    return (
        <StyledMenuColumn
            key={item.title}
            role="group"
            aria-labelledby={columnId}
            data-section="Section"
            data-section-name={item.title}
        >
            {item.url ? (
                <MenuColumnHeadingLink
                    id={columnId}
                    href={item.url}
                    target={item.openInNewTab ? '_blank' : undefined}
                    rel={item.noFollow ? 'nofollow' : undefined}
                    $displayOption={item.displayOption}
                    $colorOption={item.colorOption}
                    $isActive={isActive}
                    data-element="Link"
                    data-element-name={item.title}
                    data-element-color-option={item.colorOption}
                >
                    {item.title}
                    {item.badge && <MenuItemBadge>{item.badge}</MenuItemBadge>}
                </MenuColumnHeadingLink>
            ) : (
                <MenuColumnHeading id={columnId} $displayOption={item.displayOption} $colorOption={item.colorOption}>
                    {item.title}
                    {item.badge && <MenuItemBadge>{item.badge}</MenuItemBadge>}
                </MenuColumnHeading>
            )}
            <MenuColumnGroup role="menu" aria-labelledby={columnId}>
                {item.children?.map((child) => (
                    <MenuColumnItem key={child.title} item={child} />
                ))}
            </MenuColumnGroup>
        </StyledMenuColumn>
    );
};
